import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import {
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
  MDSPanelHeader,
  MDSPanelHeaderSlotName,
  MDSTextColor,
} from "@/mds";

export const IntegrationsPageHeader: FC = observer(() => {
  return (
    <Wrapper>
      <MDSPanelHeader>
        <MDSText
          slot={MDSPanelHeaderSlotName.Heading}
          variant={MDSTextVariant.HeaderXl}
          weight={MDSTextWeight.SemiBold}
          color={MDSTextColor.Contrast}
          numberOfLines={1}
        >
          Integrations
        </MDSText>
      </MDSPanelHeader>
    </Wrapper>
  );
});

const Wrapper = styled.div(() => ({}));
